import { ReactComponent as Meter } from "../../../shared/assets/meter.svg";
import { ReactComponent as Petrol } from "../../../shared/assets/petrol.svg";
import { themeAtom } from "../../../shared/atoms";
import { valOrNa } from "../../../shared/services/utils";
import { PerfTableCol } from "../../models/vessel-details.models";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

// TODO improve interface and enable any option to be disabled, not just speed (remove speedOptionName func param, replace with option param: enabled)
export function PerfTable(
  cols: PerfTableCol[],
  speedOptionName: string,
  visCols: string[],
  speedInfo: any[],
  speedDataBallast: any[],
  speedDataLaden: any[],
  MenuButton?: () => JSX.Element,
) {
  const theme = useAtomValue(themeAtom);

  return (
    <div className={`flex flex-col`}>
      {MenuButton && (
        <div className="... flex justify-end">
          <MenuButton />
        </div>
      )}

      <div className={twMerge("... rounded border", theme.uwhcAssistant.border)}>
        <table className={twMerge("min-w-full divide-y", theme.uwhcAssistant.border)}>
          <thead className={twMerge("text-xs font-semibold", theme.uwhcAssistant.text)}>
            <tr>
              <th>&nbsp;</th>
              {cols.map((col) =>
                visCols.includes(col.accessor) ? (
                  <th
                    key={col.accessor}
                    className="w-1/5 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    {col.header}
                  </th>
                ) : null,
              )}
            </tr>
          </thead>

          <tbody className={twMerge("divide-y", theme.uwhcAssistant.border, theme.home.tailwind.panelBackground)}>
            {speedInfo && speedDataBallast.length > 0 ? (
              speedDataBallast.map((row, index) => (
                <tr key={index} className={twMerge("border-b", theme.uwhcAssistant.border)}>
                  {index === 0 ? (
                    <td
                      className={twMerge("relative p-0 align-top text-xs", theme.vesselDetails.info)}
                      rowSpan={speedDataBallast.length}
                    >
                      <div
                        className={twMerge(
                          "absolute inset-0 grid w-12 place-items-center border-r",
                          theme.vesselDetails.emerald,
                          theme.uwhcAssistant.border,
                        )}
                      >
                        <div
                          className={twMerge(
                            "font-['Be Vietnam Pro'] origin-center -rotate-90 text-center text-xs font-semibold leading-none",
                            theme.uwhcAssistant.text,
                          )}
                        >
                          Ballast
                        </div>
                      </div>
                    </td>
                  ) : (
                    ""
                  )}

                  {cols.map(
                    (col) =>
                      visCols.includes(col.accessor) && (
                        <td
                          key={col.accessor}
                          className={twMerge("w-1/5 whitespace-nowrap px-6 py-3 text-xs", theme.vesselDetails.info)}
                        >
                          <div className="flex items-center justify-start">
                            {col.accessor === speedOptionName ? (
                              <>
                                <Meter className="mr-2 h-5 w-4" />
                                <p>{valOrNa(row[col.accessor], "kn")}</p>
                              </>
                            ) : (
                              <>
                                <Petrol className="mr-2 h-5 w-4" />
                                {valOrNa(row[col.accessor], "mt")}
                              </>
                            )}
                          </div>
                        </td>
                      ),
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={cols.length}
                  className={twMerge("px-6 py-4 text-center text-xs", theme.vesselDetails.info)}
                >
                  No data available
                </td>
              </tr>
            )}

            {speedInfo && speedDataLaden.length > 0 ? (
              speedDataLaden.map((row, index) => (
                <tr key={index + "laden"} className={twMerge("border-b", theme.uwhcAssistant.border)}>
                  {index === 0 ? (
                    <td
                      className={twMerge("relative p-0 align-top text-xs", theme.vesselDetails.info)}
                      rowSpan={speedDataLaden.length}
                    >
                      <div
                        className={twMerge(
                          "absolute inset-0 grid w-12 place-items-center border-r",
                          theme.uwhcAssistant.border,
                          theme.vesselDetails.emerald,
                        )}
                      >
                        <div
                          className={twMerge(
                            "font-['Be Vietnam Pro'] origin-center -rotate-90 text-center text-xs font-semibold leading-none",
                            theme.uwhcAssistant.text,
                          )}
                        >
                          Laden
                        </div>
                      </div>
                    </td>
                  ) : (
                    ""
                  )}

                  {cols.map(
                    (col) =>
                      visCols.includes(col.accessor) && (
                        <td
                          key={col.accessor}
                          className={twMerge("w-1/5 whitespace-nowrap px-6 py-3 text-xs", theme.vesselDetails.info)}
                        >
                          <div className="flex items-center justify-start">
                            {col.accessor === speedOptionName ? (
                              <>
                                <Meter className={twMerge("mr-2 h-5 w-4", theme.vesselDetails.info)} />
                                <p>{valOrNa(row[col.accessor], "kn")}</p>
                              </>
                            ) : (
                              <>
                                <Petrol className="mr-2 h-5 w-4" />
                                {valOrNa(row[col.accessor], "mt")}
                              </>
                            )}
                          </div>
                        </td>
                      ),
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={cols.length}
                  className={twMerge("px-6 py-4 text-center text-xs", theme.vesselDetails.info)}
                >
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
